import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { normalizeProvider } from "@smithy/util-middleware";
import { getEndpointFromConfig } from "./adaptors/getEndpointFromConfig";
import { toEndpointV1 } from "./adaptors/toEndpointV1";
export var resolveEndpointConfig = function resolveEndpointConfig(input) {
  var _input$tls, _input$useDualstackEn, _input$useFipsEndpoin;
  var tls = (_input$tls = input.tls) !== null && _input$tls !== void 0 ? _input$tls : true;
  var endpoint = input.endpoint;
  var customEndpointProvider = endpoint != null ? /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = toEndpointV1;
            _context.next = 3;
            return normalizeProvider(endpoint)();
          case 3:
            _context.t1 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1));
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })) : undefined;
  var isCustomEndpoint = !!endpoint;
  var resolvedConfig = _objectSpread(_objectSpread({}, input), {}, {
    endpoint: customEndpointProvider,
    tls: tls,
    isCustomEndpoint: isCustomEndpoint,
    useDualstackEndpoint: normalizeProvider((_input$useDualstackEn = input.useDualstackEndpoint) !== null && _input$useDualstackEn !== void 0 ? _input$useDualstackEn : false),
    useFipsEndpoint: normalizeProvider((_input$useFipsEndpoin = input.useFipsEndpoint) !== null && _input$useFipsEndpoin !== void 0 ? _input$useFipsEndpoin : false)
  });
  var configuredEndpointPromise = undefined;
  resolvedConfig.serviceConfiguredEndpoint = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (input.serviceId && !configuredEndpointPromise) {
              configuredEndpointPromise = getEndpointFromConfig(input.serviceId);
            }
            return _context2.abrupt("return", configuredEndpointPromise);
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return resolvedConfig;
};